class VariantSelector {
  constructor() {
    this.initAddToCartButtons();
  }

  initAddToCartButtons() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.quick-add__submit[data-multi-variant="true"]');
      if (button) {
        event.preventDefault();
        this.handleAddToCart(button);
      }
    });
  }

  async handleAddToCart(button) {
    const productId = button.dataset.productId;
    const spinner = button.querySelector('.loading-spinner');
    
    try {
      spinner.classList.remove('hidden');
      // Fetch product data
      const response = await fetch(window.Shopify.routes.root + `products/${button.dataset.productUrl}.js`);
      const productData = await response.json();
      
      // Find highest priced variant that's in stock
      const highestPricedVariant = this.findHighestPricedInStockVariant(productData.variants);
      
      if (highestPricedVariant) {
        // Add to cart
        await this.addToCart(highestPricedVariant.id, 1);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      spinner.classList.add('hidden');
    }
  }

  findHighestPricedInStockVariant(variants) {
    return variants
      .filter(variant => variant.available)
      .sort((a, b) => parseFloat(b.price) - parseFloat(a.price))[0];
  }

  async addToCart(variantId, quantity) {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');
    
    // Refresh cart
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  }
}

// Initialize
customElements.define('variant-selector', class extends HTMLElement {
  connectedCallback() {
    new VariantSelector();
  }
});